import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { edibleOilsData, oilCategoryLabels } from '../data/edibleOilsData';
import { Search, Filter, ChevronRight, Droplets } from 'lucide-react';

// AI-Generated high-resolution images for edible oils
const oilImages = {
  'groundnut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/1cef593f22e6d24e5ac20965ddf1d86a40b283753ae6cfb6af29c368b8610296.png',
  'sesame-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/890e914726ad218ad56978dffd0c5de7e1a74233fd93f3bb59365dd2731763c9.png',
  'mustard-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/0805c1a056e56f47ee1cdad4acd291f46917502118944af0b60d5989ca398b04.png',
  'coconut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/408f463b0af418974e800bdda4e158fbce7114be6c581d5233196a694add95d9.png',
  'sunflower-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/b0de4ba437023dbe4aa95ad3c2bcb7e04fe5e0508e9c5179650b4fac0ee086c7.png',
  'soybean-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/526074fa569997b41f081183579ba14f7802b13f956a7a0a29fa5d66c66b8deb.png',
  'rice-bran-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/98a1c8e86d72f225e7d1e6297a9d712ba5d7b4c5e0a222eb65d7cef2293a4163.png',
  'safflower-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/5aae194828f2c00ca77886a9bb9e0960bc786b99cf9c1487812a7f7db0ad0181.png',
  'cottonseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/53dd411097729d29251d16a715160522dc8f44df76f955a0c012849179011daf.png',
  'palm-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/60f72805fd9a45e496c424039b456177c86390133e59179747d8ba11f8ffabab.png',
  'castor-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/2c6948adc466552aa602d6021b8ecbc7a8473012ea60d8a4f3ac042045fece28.png',
  'linseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/43083a976183b98aea78bfa761eeb8508377e3f6bd4353de8ff684a1b7c9290e.png',
  'niger-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6b3d2ee467a1bc7ce6788cc38376fc37bbc41a73f183305c4d7f252e8b6eef30.png',
  'olive-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/d151e52bf6aaacd516678042204e23df8a464c8de5c39856e41dea329e3c649f.png',
  'corn-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/7a20643e96143cb2e556db2a65af15929f7373f063b8dd5509574db1693016f5.png',
  'rapeseed-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/bf1a703fca7666d4b830ed3127d3c5c7785152103e527b7276ea7083a8e8c2da.png',
  'ghee': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ba5ecfde5fd740b840d2a434224229e453fb85da287e6024f1cefa6497babc7f.png',
  'butter': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ceedcf5593f3fbcb20ad00e34eaa1cef355561df9e27cef981d8cba94ea80e07.png',
  'avocado-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/d0ca01d4bad8b0cdc2989988580169ac9b162ac3c537e59100164341bffc5f2e.png',
  'walnut-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/4b2a5405aa0f261bddb66878205fd712ebf12f4d3c425a38bc07889c73f2e6a5.png',
  'almond-oil': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/07d9d638e4d6305a9919b68dd7664a41b6f04bbd37d7ed5840a3dd6294668c05.png',
};

const getOilImage = (imageKey) => {
  return oilImages[imageKey] || 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400&h=300&fit=crop';
};

export default function EdibleOilsCatalogue() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredOils = useMemo(() => {
    return edibleOilsData.filter(oil => {
      const matchesSearch = oil.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           oil.botanicalName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           oil.source.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || oil.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const categories = useMemo(() => {
    const cats = [...new Set(edibleOilsData.map(o => o.category))];
    return cats.sort((a, b) => oilCategoryLabels[a].localeCompare(oilCategoryLabels[b]));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">Edible Oils & Fats</span>
          </nav>
          
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 bg-[#F47D20]/20 rounded-xl flex items-center justify-center">
              <Droplets className="w-7 h-7 text-[#F47D20]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold">Edible Oils & Fats</h1>
          </div>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mb-8">
            India is a major producer and exporter of edible oils. Explore our comprehensive catalogue featuring 
            over 20 premium oils and fats sourced from trusted suppliers with complete quality assurance.
          </p>
          
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search oils..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent"
                data-testid="oil-search-input"
              />
            </div>
            <div className="relative">
              <Filter className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full sm:w-auto pl-12 pr-8 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent appearance-none cursor-pointer"
                data-testid="oil-category-filter"
              >
                <option value="all" className="bg-[#263776]">All Categories</option>
                {categories.map(cat => (
                  <option key={cat} value={cat} className="bg-[#263776]">
                    {oilCategoryLabels[cat]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Oils Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex items-center justify-between mb-8">
          <p className="text-gray-600">
            Showing <span className="font-semibold text-[#263776]">{filteredOils.length}</span> products
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredOils.map((oil) => (
            <Link
              key={oil.id}
              to={`/products/edible-oils/${oil.id}`}
              className="group bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
              data-testid={`oil-card-${oil.id}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={getOilImage(oil.image)}
                  alt={oil.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="absolute top-3 right-3 px-2 py-1 bg-[#F47D20] text-white text-xs font-medium rounded-full">
                  {oilCategoryLabels[oil.category]}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-[#263776] group-hover:text-[#F47D20] transition-colors mb-1">
                  {oil.name}
                </h3>
                <p className="text-sm text-gray-500 mb-2">Source: {oil.source}</p>
                <p className="text-sm text-gray-600 line-clamp-2">
                  {oil.description.substring(0, 100)}...
                </p>
                <div className="mt-3 flex items-center text-[#F47D20] text-sm font-medium">
                  View Details
                  <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredOils.length === 0 && (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No products found</h3>
            <p className="text-gray-500">Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="bg-[#263776] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Premium Quality Edible Oils</h2>
            <p className="text-gray-300 mb-8">
              SPANXPORT sources edible oils directly from certified mills and refineries, ensuring 
              the highest quality standards. Our rigorous quality control processes guarantee 
              compliance with international food safety certifications including FSSAI, ISO 22000, and HACCP.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">20+</div>
                <div className="text-sm text-gray-300">Oil Varieties</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">100%</div>
                <div className="text-sm text-gray-300">Quality Assured</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">FSSAI</div>
                <div className="text-sm text-gray-300">Certified</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">Bulk</div>
                <div className="text-sm text-gray-300">& Retail Packaging</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="bg-gradient-to-r from-[#F47D20] to-[#ff9a4d] rounded-2xl p-8 md:p-12 text-white text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Need Bulk Edible Oil?</h2>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Contact our team for competitive pricing on bulk orders, custom specifications, 
            private labeling, and tailored packaging solutions for your business needs.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-white text-[#F47D20] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="oil-catalogue-get-quote-btn"
          >
            Get a Quote
            <ChevronRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
}
